import { useState, useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';

// Peacock components
import { Button, DatePickerInput } from 'pepsico-ds';

// Custom Components
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';
import OktaStatusTable from '@/containers/OnboardingStatus/OktaStatusTable';

// Constants
import { ROUTES } from '@/utils/constants/routesConstants';
import StoresMissingDataTable from '@/containers/OnboardingStatus/StoresMissingDataTable';
import {
  useMissingActivity,
  useMissingPromo,
  useMissingSegments,
  useMissingTargets
} from '@/services/Onboarding/onboardingService';
import DateRangeSelector from '@/components/common/DateRangeSelector/DateRangeSelector';

const StoresMissingDataView = () => {
  const [dateRange, setDateRange] = useState({
    startDate: new Date(2023, 0, 1), // Jan 1, 2023
    endDate: (() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow;
    })(),
    isValid: true
  });

  const location = useLocation();

  const shouldLoadData = useMemo(() => {
    return !!dateRange.startDate && !!dateRange.endDate && dateRange.isValid;
  }, [dateRange]);

  const useMissingMainTargets = (page, pageSize, filters, startDate, endDate, options = {}) => {
    return useMissingTargets(page, pageSize, filters, startDate, endDate, 'main', options);
  };

  const useMissingProductTargets = (page, pageSize, filters, startDate, endDate, options = {}) => {
    return useMissingTargets(page, pageSize, filters, startDate, endDate, 'product', options);
  };





  const config = useMemo(() => {
    const path = location.pathname;
    if (path.includes('missing-promo-data')) {
      return {
        title: 'Missing Promo Data',
        fetchFunction: useMissingPromo,
        downloadFileName: 'missing-promo-data.csv'
      };
    }
    if (path.includes('missing-activity-data')) {
      console.log('missing-activity-data');
      return {
        title: 'Missing Activity Data',
        fetchFunction: useMissingActivity,
        downloadFileName: 'missing-activity-data.csv'
      };
    }
    if (path.includes('missing-segments-data')) {
      return {
        title: 'Missing Segments Data',
        fetchFunction: useMissingSegments,
        downloadFileName: 'missing-segments-data.csv'
      };
    }
    if (path.includes('missing-main-targets-data')) {
      return {
        title: 'Missing Main Targets Data',
        fetchFunction: useMissingMainTargets,
        downloadFileName: 'missing-main-targets-data.csv'
      };
    }
    if (path.includes('missing-product-targets-data')) {
      return {
        title: 'Missing Product Targets Data',
        fetchFunction: useMissingProductTargets,
        downloadFileName: 'missing-product-targets-data.csv'
      };
    }
    return {
      title: 'Missing Promo Data',
      fetchFunction: useMissingPromo,
      downloadFileName: 'missing-promo-data.csv'
    };
  }, [location.pathname]);

  return (
    <div>
      <DateRangeSelector
        onDatesChange={setDateRange}
        initialStartDate={dateRange.startDate}
        initialEndDate={dateRange.endDate}
      />

      {!shouldLoadData ? (
        <div className='text-center p-8'>
          <p>Please select both start and end dates to load the table data.</p>
        </div>
      ) : (
        <div className=''>
          <StoresMissingDataTable
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            config={config}
          />
        </div>
      )}
    </div>
  );
};

export default StoresMissingDataView;
